import { Fragment } from 'react';

import BreadcrumbStep from './BreadcrumbStep';
import { Divider, Wrapper } from './styled';

type Props = {
  activeStep: number;
  stepsNames: string[];
};

const WizardBreadcrumb = ({ activeStep, stepsNames }: Props): JSX.Element => {
  const stepsCount = stepsNames.length;

  return (
    <Wrapper data-testid="wizardBreadcrumb">
      {stepsNames.map((stepName, index) => (
        <Fragment key={index}>
          <BreadcrumbStep isCompleted={index < activeStep} stepName={stepName} />
          {index !== stepsCount - 1 && <Divider />}
        </Fragment>
      ))}
    </Wrapper>
  );
};

export default WizardBreadcrumb;
